// Import model
import { FilterProposalLineRequest } from '../models/FilterProposalLineRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ProposalLineCondition } from '../models/ProposalLineCondition';
import { ProposalLineFields } from '../models/ProposalLineFields';
import { ProposalLineIndexedFields } from '../models/ProposalLineIndexedFields';

// Import dependency serializers (for complex types)
import { ProposalLineConditionSerializer } from './ProposalLineConditionSerializer';
import { ProposalLineFieldsSerializer } from './ProposalLineFieldsSerializer';
import { ProposalLineIndexedFieldsSerializer } from './ProposalLineIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterProposalLineRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterProposalLineRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterProposalLineRequest instance
   */
  static deserialize(json: string): FilterProposalLineRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterProposalLineRequest instance
   */
  static fromObject(obj: any): FilterProposalLineRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterProposalLineRequest');
    }


    const instance: FilterProposalLineRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as ProposalLineIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as ProposalLineFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        ProposalLineConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterProposalLineRequest instances
   */
  static deserializeArray(json: string): FilterProposalLineRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterProposalLineRequest instance to a JSON string
   */
  static serialize(instance: FilterProposalLineRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterProposalLineRequest instance to a plain object
   */
  static toObject(instance: FilterProposalLineRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        ProposalLineConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterProposalLineRequest instances to a JSON string
   */
  static serializeArray(instances: FilterProposalLineRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
